//测试地址
const title_dev = '管理系统平台'
const host_dev = ''
const img_dev = ''
// 线上地址
const title_online = '管理系统平台'
const host_online = ''
const img_online = ''

const env = process.env
console.log('env', env.NODE_ENV, env.ENV_TYPE)
let NODE_ENV = env.NODE_ENV
let ENV_TYPE = env.ENV_TYPE
let title = ''
let apihost = ''
let imghost = ''
let publicPath = '/'

// 开发编译模式
if (NODE_ENV === 'production') {
  if (ENV_TYPE == 'online') {
    // online生产地址
    title = title_online
    apihost = host_online
    imghost = img_online
    publicPath = '/app/admin/'
  }
  if (ENV_TYPE == 'dev') {
    // dev生产地址
    title = title_dev
    apihost = host_dev
    imghost = img_dev
    publicPath = '/app/admin/'
  }
} else {
  // dev开发地址
  title = title_dev
  apihost = host_dev
  imghost = img_dev
  publicPath = '/'
}

console.log('title', title)
console.log('apihost', apihost)
console.log('imghost', imghost)
console.log('publicPath', publicPath)
console.log('env_type', ENV_TYPE)

module.exports = {
  env: NODE_ENV,
  env_type: ENV_TYPE,
  title: title,
  API_HOST: apihost,
  IMAGE_HOST: imghost,
  publicPath: publicPath,
}
